import * as types from '../../../../types/masters/stoneAttribute/stoneType/stoneTypeTypes';
import * as api from '../../../../../api/masters/stoneAttribute/stoneType/stoneTypeApi';

export const fetchStoneTypes = () => async (dispatch) => {
  dispatch({ type: types.FETCH_STONETYPE_REQUEST });
  try {
    const data = await api.fetchStoneTypes();
    dispatch({ type: types.FETCH_STONETYPE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: types.FETCH_STONETYPE_FAILURE, payload: error.message });
  }
};

export const addStoneType = (stoneType) => async (dispatch) => {
  try {
    const res = await api.addStoneType(stoneType);
    dispatch({ type: types.ADD_STONETYPE_SUCCESS, payload: res });
    dispatch(fetchStoneTypes());
  } catch (error) {
    dispatch({ type: types.STONETYPE_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const updateStoneType = (id, stoneType) => async (dispatch) => {
  try {
    const res = await api.updateStoneType(id, stoneType);
    dispatch({ type: types.UPDATE_STONETYPE_SUCCESS, payload: res });
    dispatch(fetchStoneTypes());
  } catch (error) {
    dispatch({ type: types.STONETYPE_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const deleteStoneType = (id) => async (dispatch) => {
  try {
    await api.deleteStoneType(id);
    dispatch({ type: types.DELETE_STONETYPE_SUCCESS, payload: id });
    dispatch(fetchStoneTypes());
  } catch (error) {
    dispatch({ type: types.STONETYPE_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const setStoneTypeEdit = (stoneType) => ({
  type: types.SET_STONETYPE_EDIT,
  payload: stoneType,
});

export const clearStoneTypeEdit = () => ({
  type: types.CLEAR_STONETYPE_EDIT,
}); 